const state = {
	list: [],
	collapse: undefined,
	showLast: false,
	index1: 0,
	index2: 0,
	index3: 0,
	index4: 0,
	menuIndex1: "",
	menuIndex2: "",
	menuIndex3: ""
}

const initMenuIndex = (context, path) => {
	if (context.state.list.length == 0) {
		return;
	}
	var hasFind = false;
	path = path || V.$route.fullPath;
	context.state.list.Each((f, fi) => {
		if (f.path == path) {
			// console.log("一级找到");
			context.commit('SetIndex', {
				index1: fi,
				index2: 0,
				index3: 0,
				index4: 0,
				menuIndex1: f.route,
				showLast: false
			})
			hasFind = true;
		} else if (f.sub != undefined && f.sub.length > 0) {
			f.sub.Each((s, si) => {
				if (s.path == path) {
					// console.log("二级找到");
					context.commit('SetIndex', {
						index1: fi,
						index2: si,
						index3: 0,
						index4: 0,
						menuIndex1: f.route,
						menuIndex2: s.route,
						showLast: false
					})
					hasFind = true;
				} else if (s.sub != undefined && s.sub.length > 0) {
					s.sub.Each((t, ti) => {
						if (t.path == path) {
							// console.log("三级找到");
							context.commit('SetIndex', {
								index1: fi,
								index2: si,
								index3: ti,
								menuIndex1: f.route,
								menuIndex2: t.route,
								showLast: false
							})
							hasFind = true;
						} else if (t.sub != undefined && t.sub.length > 0) {
							t.sub.Each((l, li) => {
								if (l.path == path) {
									// console.log("四级找到");
									context.commit('SetIndex', {
										index1: fi,
										index2: si,
										index3: ti,
										index4: li,
										menuIndex1: f.route,
										menuIndex2: t.route,
										menuIndex3: l.route,
										showLast: true
									})
									hasFind = true;
								} else if (l.sub != undefined && l.sub.length > 0) {
									l.sub.Each((ll, lli) => {
										if (ll.path == path) {
											// console.log("5级（详情页级别，不展示在页面菜单）找到");
											context.commit('SetIndex', {
												index1: fi,
												index2: si,
												index3: ti,
												index4: li,
												menuIndex1: f.route,
												menuIndex2: t.route,
												menuIndex3: l.route,
												showLast: true
											})
											hasFind = true;
										}
									});
								}
							});
						}
					});
				}
			});
		}
	});
	if (!hasFind) {
		context.commit('SetIndex', {
			index1: -1,
			index2: -1,
			index3: -1,
			index4: -1,
			menuIndex1: "",
			showLast: false
		})
	}
}

// 同步
const mutations = {
	InitMenu(state, data) {
		state.list = data;
	},
	SetIndex(state, data) {
		// console.log(data)
		if (data == undefined) {
			return;
		}
		// console.log("mutations", data)
		for (var key in data) {
			state[key] = data[key];
		}
	},
	SetCollapse(state, collapse) {
		state.collapse = collapse;
		localStorage.setItem("collapse", collapse ? 1 : 0);
	}
}

// 异步
const actions = {
	GetMenu(context) {
		V.$api.menu.getList().then(r => {
			let menuList = [{
					auth: 0,
					icon: "sz szzazhiqikan",
					route: "/chiefedit",
					sub: [{
						auth: 0,
						icon: "sz szfuzhubian",
						path: "/chiefedit",
						route: "/chiefedit",
						sub: [],
						title: "主编",
					},{
			
						auth: 0,
						icon: "sz szxueweirenzheng",
						route: "/magazine",
						path: "/magazine",
						sub: [],
						title: "科研"
					}
					// {
					// 	auth: 0,
					// 	icon: "sz szjingzhengqingbao",
					// 	route: "/information",
					// 	path: "/information",
					// 	sub: [],
					// 	title: "情报"
					// },
					],
					title: "杂志"
				},
				{
					auth: 0,
					icon: "sz sztougao",
					route: "/contribution",
					sub: [{
						auth: 0,
						icon: "el-icon-files",
						path: "/contribution",
						route: "/contribution",
						sub: [],
						title: "管理"
					},{
						auth: 0,
						icon: "el-icon-position",
						path: "/submitcontribution",
						route: "/submitcontribution",
						sub: [],
						title: "投稿"
					}],
					title: "投稿"
				},
				{
					auth: 0,
					icon: "sz szminyizhengji",
					route: "/essay",
					sub: [{
						auth: 0,
						icon: "el-icon-files",
						path: "/essay",
						route: "/essay",
						sub: [],
						title: "管理"
					},{
						auth: 0,
						icon: "el-icon-position",
						path: "/submitessay",
						route: "/submitessay",
						sub: [],
						title: "投稿"
					}],
					title: "征文"
				}
			];
			context.commit('InitMenu', menuList)
			initMenuIndex(context);
		});
	},
	//逆向初始化基本参数
	InitMenuIndex(context, path) {
		initMenuIndex(context, path);
	}
}

const getters = {
	collapse(state) {
		if (state.collapse == undefined) {
			let collapse = localStorage.getItem("collapse");
			if (collapse == null || collapse == undefined) {
				localStorage.setItem("collapse", 0);
				collapse = "0";
			}
			state.collapse = collapse == "1";
		}
		return state.collapse;
	}
}

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions
}
